import React, { useState, useEffect } from 'react';

export default function Header() {

    const [isSticky, setIsSticky] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
          if (window.pageYOffset > 0) {
            setIsSticky(true);
          } else {
            setIsSticky(false);
          }
        };
    
        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

  return (
    <>
    	<header className={isSticky ? 'sticky header-wrapper w-100 border-bottom border-light dark-border2 dark-bg' : 'header-wrapper w-100 border-bottom border-light dark-border2 dark-bg'}>
        <nav className="navbar navbar-expand-lg navbar-light border-0">
            <div className="container posr">
            <a className="navbar-brand light-logo" href="/"><img src="images/logo/avatarlab.jpg" alt="avatarlab" /></a>
            <a className="navbar-brand dark-logo" href="/"><img src="images/logo/avatarlab-dark.jpg" alt="avatarlab" /></a>
            <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon" /></button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mx-auto mb-2 mb-lg-0" id="navbar-main">
                <li className="nav-item">
                    <a className="nav-link text-white" href="#">Home</a>
                </li>
                <li className="nav-item menu-item-has-children">
                    <a className="nav-link text-white mega-menu" href="#">Developers</a>
                    <ul className="sub-menu">
                        <li className="menu-item"><a href="#">Documentations</a></li>
                        <li className="menu-item"><a href="#">Code Sample</a></li>
                        <li className="menu-item"><a href="#">Tutorials</a></li>
                        <li className="menu-item"><a href="#">Change Log</a></li>
                    </ul>
                </li>
                <li className="nav-item">
                    <a className="nav-link text-white" href="#">Blogs</a>
                </li>
                <li className="nav-item"><a className="nav-link text-white" href="#">Contact</a></li>
                </ul>
                {/* <a href="#" className="btn btn-lg menu-btn border-0 text-white rajdhani-600 rounded-6 bg-gray-900 px-4 font-sm text-uppercase" data-bs-toggle="modal" data-bs-target="#connetwallet"> Connect Wallet</a> */}
                <a href="#" className="btn btn-lg menu-btn border-0 text-white rajdhani-600 rounded-6 bg-gray-900 px-4 font-sm text-uppercase"> Connect Wallet</a>
                <a href="#" className="ms-2 btn menu-btn btn-noti"><i className="bi-bell font-md m-0" /><span className="dot-count bg-current rajdhani-600">6</span></a>
                <a href="#" data-switch-theme className="ms-2 menu-btn btn-toggle-dark btn btn-icon btn-round"><i className="bi-brightness-low font-xl m-0" /></a>
            </div>
            <a href="#" id="connetw" className="btn btn-md header-btn text-gray-white rajdhani-700 rounded-6 bg-current px-4 font-sm text-uppercase dark-text" data-bs-toggle="modal" data-bs-target="#connetwallet"> Connect Wallet</a>
            <a href="#" className="account posr header-btn" id="accountAvater">
                <figure className="avater avater-online mb-0"><img src="images/avater-2.png" alt="user" className="w-45" /></figure>
                <div className="menu-dropdown p-0 text-center">
                <h4 className="lh-18 mb-4 border-light border-bottom text-center h6 rajdhani-600" style={{padding: '15px 0'}}>Account <span className="d-block font-xs text-gray-500 mw-110 mx-auto ovh" id="accountid">0xaf6c0d1c5a771ad79314e0cc17c2fc98efad8819</span></h4>
                <div className="d-flex justify-content-center text-center flex-column">
                    <img src="images/icon-13.png" alt="icon" className="w-55 rounded-circle border p-2 mx-auto" />
                </div>
                <div className="d-flex flex-column pt-0 text-center justify-content-center mt-3 mb-2">
                    <h6 className="d-block font-xss inter-500 text-gray-500 ls-2 mt-0 mb-1"><i className="bi-wallet2" /> Wallet balance </h6>
                    <h1 className="h5 text-gray-800 ls-0 inter-700 lh-32 m-0"><span>ETH </span> <span id="accountbal">5685.00 </span></h1>
                    <h6 className="text-success font-xs mt-auto rajdhani-600 lh-1 mb-0"><i className="bi-caret-up-fill font-xssss" /> 0.46%</h6>
                </div>
                <div className="d-block p-0 mb-2">
                    <ul className="nav nav-pills nav-line-bottom current-color nav-justified border-bottom">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link d-block lh-28 pb-2 active" id="home-tabb" data-bs-toggle="tab" data-bs-target="#post" type="button" role="tab" aria-controls="post" aria-selected="true">Instant</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link d-block lh-28 pb-2" id="profile-tabb" data-bs-toggle="tab" data-bs-target="#media" type="button" role="tab" aria-controls="media" aria-selected="false">Limit</button>
                    </li>
                    </ul>		
                </div>
                <div className="tab-content">
                    {/* post tab */}
                    <div className="tab-pane fade active show p-3 pt-0" id="post" role="tabpanel" aria-labelledby="home-tabb">
                    <ul className="list-group list-group-flush w-100 mt-2">
                        <li className="list-group-item px-0">
                        <div className="d-flex justify-content-between align-items-start gap-2">
                            <span className="btn btn-icon btn-md border-0 bg-lightblue rounded-pill"><img src="images/btc.svg" alt="crypto" className="w-45" /></span>
                            <div className="me-auto text-grey-500 text-start">
                            <h5 className="text-grey-900 rajdhani-600 lh-26 text-start m-0 font-xs">Bitcoin</h5>
                            <h6 className="font-xss text-gray-500 lh-1 mb-0">BTC</h6>
                            </div>
                            <div className="text-end">
                            <h5 className="text-grey-900 rajdhani-600 lh-26 text-start m-0 font-xs">16,886.13 USD</h5>
                            <h6 className="font-xss text-danger rajdhani-600 lh-1 mb-0"><i className="bi-caret-down-fill font-xssss" /> 0.45%</h6>
                            </div>					        
                        </div>
                        <div className="d-flex flex-column py-2 ps-5 ms-1">
                            <h5 className="text-danger font-xss rajdhani-600 d-flex mb-1">SELL<span className="ms-auto text-gray-500 rajdhani-600">Qty 5 BTC</span></h5>
                            <h6 className="text-gray-500 font-xss rajdhani-500 d-flex mb-0">22 Nov 2022 <span className="ms-auto">Total: 234.65 USD</span></h6>
                        </div>
                        </li>
                        <li className="list-group-item px-0">
                        <div className="d-flex justify-content-between align-items-start gap-2">
                            <span className="btn btn-icon btn-md bg-lightblue rounded-pill border-0"><img src="images/eth.svg" alt="crypto" className="w-35" /></span>
                            <div className="me-auto text-grey-500 text-start">
                            <h5 className="text-grey-900 rajdhani-600 lh-26 text-start m-0 font-xs">Ethereum</h5>
                            <h6 className="font-xss text-gray-500 lh-1 mb-0">ETH</h6>
                            </div>
                            <div className="text-end">
                            <h5 className="text-grey-900 rajdhani-600 lh-26 text-start m-0 font-xs">1,262.91 USD </h5>
                            <h6 className="font-xss text-success rajdhani-600 lh-1 mb-0"><i className="bi-caret-up-fill font-xssss" /> 0.22%</h6>
                            </div>					        
                        </div>
                        <div className="d-flex flex-column py-2 ps-5 ms-1">
                            <h5 className="text-success font-xss rajdhani-600 d-flex mb-1">BUY<span className="ms-auto text-gray-500 rajdhani-600">Qty 22 ETH</span></h5>
                            <h6 className="text-gray-500 font-xss rajdhani-500 d-flex mb-0">22 Nov 2022 <span className="ms-auto">Total: 2434.65 USD</span></h6>
                        </div>
                        </li>
                    </ul>
                    </div>
                    {/* post tab */}
                    <div className="tab-pane fade p-3" id="media" role="tabpanel" aria-labelledby="profile-tabb">
                    <img src="images/empty.svg" alt="icon" />
                    <h5 className="text-gray-800 mt-3 mb-0 rajdhani-600 font-sm rajdhani-600">You dont have any order yet</h5>
                    <p className="rajdhani-500 text-gray-500 font-xssss mb-3 lh-22">Place your first order!</p>
                    </div>
                </div>
                </div>
            </a>
            <a href="#" className="ms-2 btn header-btn btn-noti"><i className="bi-bell font-md m-0" /><span className="dot-count bg-current rajdhani-600">6</span></a>
            <a href="#" data-switch-theme className="ms-2 header-btn btn-toggle-dark btn btn-icon btn-round"><i className="bi-brightness-low font-xl m-0" /></a>
            </div>
        </nav>
        </header>
    </>
  )
}
